import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StudentQRCode } from '../data/student-qr-code';
import { QRCodeComponent } from 'angularx-qrcode';
import { PrintQrCodesComponent } from '../print-qr-codes/print-qr-codes.component';
import { EmailCertificateModalComponent } from '../email-certificate-modal/email-certificate-modal.component';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-student-qr-modal-content',
  templateUrl: './student-qr-modal-content.component.html',
  styleUrls: ['./student-qr-modal-content.component.css']
})
export class StudentQrModalContentComponent implements OnInit {
  @Input() Student: StudentQRCode;
  @ViewChild('qrcode', { static: false }) qrCode: QRCodeComponent;
  @ViewChild(PrintQrCodesComponent, { static: false }) printComponent: PrintQrCodesComponent;
  @ViewChild("emailModal", { static: false }) emailModal: EmailCertificateModalComponent;

  isParent: boolean;

  constructor( private authService: AuthService ) { }

  ngOnInit(): void {
    this.isParent = this.authService.isParent();
  }

  emailQR(): void {
    const base64 = this.getQRCanvas().toDataURL("image/png").split(';base64,')[1];
    const subject = `Login Code for ${this.Student.StudentName}`
    this.emailModal.addAttachment(subject, base64);
    this.emailModal.openForNew();
  }

  printQR(): void {
    this.printComponent.printDiv();
  }

  downloadQR(): void {
    const anchor = document.createElement("a");
    anchor.href = this.getQRCanvas().toDataURL("image/png");
    anchor.download = "qr-login-code.png";
    anchor.click();
  }

  getQRData(): string {
    return `{ "JoyToken": "${this.Student.JoyToken}" }`;
  }
  
  getQRCanvas(): HTMLCanvasElement {
    return this.qrCode.qrcElement.nativeElement.firstChild;
  }

}
